import { render, staticRenderFns } from "./LawyerIndex.vue?vue&type=template&id=4e7dbc44&scoped=true"
import script from "./LawyerIndex.vue?vue&type=script&lang=js"
export * from "./LawyerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7dbc44",
  null
  
)

export default component.exports